export default __webpack_public_path__ + "static/media/dan-forbes.deca9e5c.jpeg";